import React from "react";
import ContentManagement from "../ContentManagement/ContentManagement";
import topicManagementService from "../../services/TopicManagementService";
import { CONTENT_TYPES_CONFIG } from "../../config/App.config";

const EducationalContent = () => {
  return (
    <ContentManagement
      service={topicManagementService}
      pageSize={10}
      sidebarItemLayout="horizontal"
      // use the educational content title as the slug
      getSlug="title"
      contentType={CONTENT_TYPES_CONFIG.TOPIC}
    />
  );
};

export default EducationalContent;